export const UMB_ENTITY_CREATE_OPTION_ACTION_LIST_MODAL_ALIAS = 'Umb.Modal.Entity.CreateOptionActionList';
export { UMB_ENTITY_CREATE_OPTION_ACTION_LIST_MODAL } from './entity-create-option-action-list-modal.token.js';
